(function () {
  'use strict';

  var FORM_WIDTH = '1024px';
  var STYLE_ID = 'gebest-forms-width';
  var FORM_SELECTOR = 'shopify-forms-embed, form-embed';
  var WIDTH_CSS =
    ':host {' +
    '  --inline-container-max-width: ' + FORM_WIDTH + ' !important;' +
    '  --container-max-w: ' + FORM_WIDTH + ' !important;' +
    '  display: block !important;' +
    '  width: 100% !important;' +
    '  max-width: ' + FORM_WIDTH + ' !important;' +
    '  margin-left: auto !important;' +
    '  margin-right: auto !important;' +
    '}' +
    '[class*="_formContainer_"],' +
    '[class*="formContainer"],' +
    '#app-embed,' +
    'form {' +
    '  max-width: ' + FORM_WIDTH + ' !important;' +
    '  width: 100% !important;' +
    '}';

  function addWidthStyle(map) {
    if (!(map instanceof Map)) return;
    map.set('gebest-forms-width', WIDTH_CSS);
  }

  // Intercept Forms' formStyles assignment so we append AFTER their sheets exist.
  // Do NOT create an empty Map ourselves — that prevents Forms from loading styles.
  var formStylesValue;
  try {
    Object.defineProperty(window, 'formStyles', {
      configurable: true,
      enumerable: true,
      get: function () {
        return formStylesValue;
      },
      set: function (value) {
        formStylesValue = value;
        addWidthStyle(value);
      }
    });
  } catch (error) {
    // Fallback if property is already defined.
  }

  function applyHostStyles(el) {
    if (!el) return;
    el.style.setProperty('--inline-container-max-width', FORM_WIDTH, 'important');
    el.style.setProperty('--container-max-w', FORM_WIDTH, 'important');
    el.style.setProperty('max-width', FORM_WIDTH, 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('margin-left', 'auto', 'important');
    el.style.setProperty('margin-right', 'auto', 'important');
  }

  function injectShadowStyles(el) {
    if (!el || !el.shadowRoot) return false;

    var root = el.shadowRoot;
    var existing = root.getElementById(STYLE_ID);
    if (existing) {
      existing.textContent = WIDTH_CSS;
    } else {
      try {
        var sheet = new CSSStyleSheet();
        sheet.replaceSync(WIDTH_CSS);
        root.adoptedStyleSheets = (root.adoptedStyleSheets || []).concat([sheet]);
      } catch (error) {
        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = WIDTH_CSS;
        root.appendChild(style);
      }
    }

    root.querySelectorAll('[class*="_formContainer_"], [class*="formContainer"], #app-embed, form').forEach(function (node) {
      node.style.setProperty('max-width', FORM_WIDTH, 'important');
      node.style.setProperty('width', '100%', 'important');
    });

    return true;
  }

  function resizeForms() {
    addWidthStyle(window.formStyles);

    document.querySelectorAll('[data-form-root], [data-forms-id]').forEach(applyHostStyles);
    document.querySelectorAll(FORM_SELECTOR).forEach(function (el) {
      applyHostStyles(el);
      injectShadowStyles(el);
    });
  }

  function start() {
    resizeForms();

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        resizeForms();
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      resizeForms();
      if (document.querySelector(FORM_SELECTOR) || attempts >= 80) {
        if (attempts >= 20) window.clearInterval(timer);
      }
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
